import { Controller } from "@hotwired/stimulus";
import { geocodeUsAddress } from "../services/appleMapService";

export default class extends Controller {
  static targets = ["display", "form", "input"];
  static values = { geoHint: Object };

  edit() {
    this.displayTarget.classList.add("d-none");
    this.formTarget.classList.remove("d-none");
    this.inputTarget.select();
  }

  cancel() {
    this.formTarget.classList.add("d-none");
    this.displayTarget.classList.remove("d-none");
  }

  async submit(event) {
    if (this._submitting) return;
    event.preventDefault();

    const address = this.inputTarget.value?.trim();
    if (!address) return;

    try {
      // Bias toward the visitor's approximate location (Cloudflare IP geo)
      const result = await geocodeUsAddress(address, this.geoHintValue);
      this.setHiddenField("latitude", result.lat);
      this.setHiddenField("longitude", result.lng);
    } catch {
      // Geocoding failed — let the server handle it via fallback
    }

    this._submitting = true;
    this.formTarget.requestSubmit();
  }

  setHiddenField(name, value) {
    let field = this.formTarget.querySelector(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement("input");
      field.type = "hidden";
      field.name = name;
      this.formTarget.appendChild(field);
    }
    field.value = value;
  }
}
